export default "__VITE_ASSET__DveeHzra__"